/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can/view/view';
import List from 'scripts/models/base/list';
import Component from 'can/component/component';
import helpers from '../base/helpers';
import template from './photo.stache';
import 'components/modal-photo-gallery/modal-photo-gallery';

Component.extend({
    tag: 'card-photo',
    template: template,
    viewModel: {
        element: null,
        openModalGallery(event, galleryTitle, galleryUrl, gallery) {
            event.preventDefault();
            can.$(can.stache('<modal-photo-gallery {photos}="photos" {gallery-title}="galleryTitle" {gallery-url}="galleryUrl"></modal-photo-gallery>')({
                photos: gallery,
                galleryTitle,
                galleryUrl
            })).appendTo(document.body);
        }
    },
    helpers,
    events: {
        inserted($el) {
            this.viewModel.attr('element', $el);
        }
    }
});
